.
<template>
  <div class="w-full min-h-screen overflow-x-hidden overflow-y-auto bg-white" :class="showSpinner ? 'opacity-25' : ''">
    <div class="flex flex-1 h-screen">
      <main class="flex-1 h-full min-w-0 px-4 pt-4 overflow-x-hidden overflow-y-auto sm:pt-12 2xl:pt-2 lg:px-16 2xl:px-60 lg:flex"><div class="hidden lg:block w-96"></div>
        <section aria-labelledby="primary-heading" class="flex flex-col flex-1 h-full min-w-0 overflow-x-visible pt-14 lg:pt-0 lg:order-last">
          <ParticipantInfo>
            <template v-slot:header>
              <h1 class="px-4 mt-6 text-3xl text-darkBlue lg:mt-16">
                {{ $t('caregiver2.header') }}
              </h1>
            </template>

            <template v-slot:description>
              <h3 class="px-4 mt-4 mb-10 text-base font-normal text-darkBlue md:text-xl">
                {{ $t('caregiver2.description') }}
              </h3>
            </template>

            <template v-slot:content>
              <CaregiverInfo2Content :caregiverData="caregiverInfo2" @save="proceedToNext" @back="returnToPrevious"  @loading="l => showSpinner = l" />
            </template>
          </ParticipantInfo>
        </section>
      </main>
      <AppSideNavMenu :participantDetails="caregiverInfo2" :slide="slideName" :id="enrollmentId"/>
    </div>
  </div>
  <GenesysChat></GenesysChat>

  <!-- Spinner -->
  <div class="fixed flex justify-center my-3 text-gray-500 left-1/2 top-1/2" v-if="showSpinner">
    <svg class="h-8 mr-3 -ml-1 animate-spin w-7 text-gtBlue600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
  </div>
</template>

<script>
import ParticipantInfo from 'Views/EnrollmentPresentation/StaticScreens/participant_info.vue';
import CaregiverInfo2Content from 'Views/EnrollmentPresentation/TemplateInstances/caregiver_info2_content.vue';
import enrollmentService from 'Services/backend/enrollments';
import addressUtility from 'Utilities/addressUtility';
import edpService from '../../Enrollments/EnrollmentDetails/service';
import GenesysChat from "@/views/Shared/GenesysChat.vue";
import {useEnrollmentStore} from "@/stores/enrollment";
import {mapState, mapActions} from "pinia";

export default {
  name: 'CaregiverInformation2',
  mounted() {
    this.enrollmentId = this.$route.params.enrollmentId;
    this.enrolleeId = this.$route.params.enrolleeId;
    this.enrolleeType = this.$route.params.enrolleeType;
  },

  components: {
    GenesysChat,
    ParticipantInfo,
    CaregiverInfo2Content,
  },
  data() {
    return {
      enrollmentId: '',
      enrolleeId: '',
      caregiverInfo2: {
        step: 2,
        phonePrimary: '',
        phoneSecondary: '',
        email: '',
        primaryAddress: '',
        alternateAddress: '',
        county: '',
        firstName: '',
        lastName: '',
        addressPrimary: {
          addressLine1: '',
          addressLine2: '',
          city: '',
          zipcode: '',
          county: '',
          state: '',
        },
        addressSecondary: {
          addressLine1: '',
          addressLine2: '',
          city: '',
          zipcode: '',
          county: '',
          state: '',
        },
        regionId: 1,
        language: '',
      },
      slideName: 'Caregiver Information',
      showSpinner: true,
      enrolleeType: '',
    };
  },

  methods: {
    proceedToNext(data) {
      if (this.showSpinner) return;
      this.showSpinner = true;
      if (!data?.addressSecondary?.addressLine1) delete data.addressSecondary;
      const body = {
        type: 'CAREGIVER',
        caregiver: data,
      };
      enrollmentService.updateEnrolleeDetails(this.enrolleeId, body).then(
        (response) => {
          edpService.processEnrolleePresentationSavedResponse(response, this.$toast.bind(this));
          this.$router.push({ name: 'CaregiverInformation3', params: { enrollmentId: this.enrollmentId, enrolleeId: this.enrolleeId, enrolleeType: this.enrolleeType } });
        },
        (error) => {
          edpService.processEnrolleePresentationSavedResponse(error, this.$toast.bind(this));
          console.error(error);
          this.showSpinner = false;
        },
      );
    },
    returnToPrevious() {
      if (this.showSpinner) return;
      this.$router.push({ name: 'CaregiverInformation1', params: { enrollmentId: this.enrollmentId, enrolleeId: this.enrolleeId, enrolleeType: this.enrolleeType } });
    },
    ...mapActions(useEnrollmentStore, ['loadEnrollees']),
  },

  computed: {
    ...mapState(useEnrollmentStore, ['getEnrollees']),
  },

  watch: {
    getEnrollees(newEnrollees) {
      if (newEnrollees) {
        this.showSpinner = false;
        const enrollee = newEnrollees?.participant || newEnrollees?.caregiver;

        const tempEnrollees = {
          step: 2,
          phonePrimary: enrollee?.phonePrimary,
          phoneSecondary: enrollee?.phoneSecondary,
          email: enrollee?.email,
          primaryAddress: addressUtility.addressToString(enrollee?.addressPrimary),
          alternateAddress: addressUtility.addressToString(enrollee?.addressSecondary),
          county: enrollee?.addressPrimary?.county,
          firstName: enrollee?.firstName,
          lastName: enrollee?.lastName,
          regionId: 1,
          language: enrollee?.language,
          addressPrimary: {
            addressLine1: enrollee?.addressPrimary?.addressLine1,
            addressLine2: enrollee?.addressPrimary?.addressLine2,
            city: enrollee?.addressPrimary?.city,
            zipcode: enrollee?.addressPrimary?.zipcode,
            county: enrollee?.addressPrimary?.county,
            state: enrollee?.addressPrimary?.stateAbbrev,
          },
          addressSecondary: {
            addressLine1: enrollee?.addressSecondary?.addressLine1,
            addressLine2: enrollee?.addressSecondary?.addressLine2,
            city: enrollee?.addressSecondary?.city,
            zipcode: enrollee?.addressSecondary?.zipcode,
            county: enrollee?.addressSecondary?.county,
            state: enrollee?.addressSecondary?.stateAbbrev,
          },
        };

        const validAddr = enrollee?.addressSecondary;
        tempEnrollees.alternateAddress = addressUtility.addressToString(validAddr);

        this.caregiverInfo2 = Object.assign({}, this.caregiverInfo2, tempEnrollees);
      }
    },
  },

  async created() {
    this.enrolleeId = this.$route.params.enrolleeId;
    await this.loadEnrollees(this.$route.params.enrolleeId);
  },
};
</script>

<style></style>
